import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type BasicEventInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  isAdmin?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type BasicEventInfoQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    published: boolean;
    websiteState: Types.EventWebsiteState;
    featureFlags?: Array<string | null> | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventDisplayName?: string | null;
      hasEventPassword: boolean;
      eventType: Types.EventType;
      usesNewStack: boolean;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      locale: string;
      guestDisplayLocales?: Array<string> | null;
      clockFormat?: Types.ClockFormat | null;
      story?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        city?: string | null;
        country?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        name?: string | null;
        placeId?: string | null;
        state?: string | null;
        address1?: string | null;
        address2?: string | null;
        postalCode?: string | null;
      } | null;
      finalizedDate?: { __typename?: 'Date'; milliseconds: number; dateString: string; timestamp: any; timezone: string } | null;
      tentativeDate?: { __typename?: 'Date'; milliseconds: number; dateString: string; timestamp: any; timezone: string } | null;
      qanda: Array<{ __typename?: 'EventQanda'; id: string; type: Types.QandaType; question: string; answer: string }>;
    };
    firebaseCreateAt?: { __typename?: 'Date'; timestamp: any } | null;
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      id: string;
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
    settings: {
      __typename?: 'EventSettings';
      id: string;
      hideEventCountdown: boolean;
      hideDownloadAppPage: boolean;
      hideFromSearchEngines: boolean;
      hideFromJoySearch: boolean;
      requirePasswordForEventDate: boolean;
      requirePasswordForEventLocation: boolean;
      requirePasswordToUploadPhotos: boolean;
      requirePasswordToViewEngagementPhotos: boolean;
      privacyMode: Types.PrivacyModeType;
      optOutOfCharm: boolean;
      allowFacebookAndInstagramSharingOnApp: boolean;
      allowGuestsNotInGuestListToRSVP: boolean;
      allowGuestsToInviteOtherGuestsOnApp: boolean;
      allowGuestsToRSVPPlusOne: boolean;
      allowGuestsToViewOtherGuestsOnApp: boolean;
      requiresGuestIdentification: boolean;
    };
  } | null;
};

export const BasicEventInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BasicEventInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicEventInfoFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicEventInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasEventPassword' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usesNewStack' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestDisplayLocales' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clockFormat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tentativeDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'story' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'qanda' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventQanda' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productVerticals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideEventCountdown' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideDownloadAppPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromSearchEngines' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromJoySearch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventLocation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordToUploadPhotos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordToViewEngagementPhotos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'privacyMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfCharm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowFacebookAndInstagramSharingOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsNotInGuestListToRSVP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToInviteOtherGuestsOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToRSVPPlusOne' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToViewOtherGuestsOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresGuestIdentification' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventQanda' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventQanda' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'question' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBasicEventInfoQuery__
 *
 * To run a query within a React component, call `useBasicEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicEventInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useBasicEventInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicEventInfoQuery, BasicEventInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<BasicEventInfoQuery, BasicEventInfoQueryVariables>(BasicEventInfoDocument, baseOptions);
}
export function useBasicEventInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicEventInfoQuery, BasicEventInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<BasicEventInfoQuery, BasicEventInfoQueryVariables>(BasicEventInfoDocument, baseOptions);
}
export type BasicEventInfoQueryHookResult = ReturnType<typeof useBasicEventInfoQuery>;
export type BasicEventInfoLazyQueryHookResult = ReturnType<typeof useBasicEventInfoLazyQuery>;
export type BasicEventInfoQueryResult = Apollo.QueryResult<BasicEventInfoQuery, BasicEventInfoQueryVariables>;
